import * as React from 'react';
import { useContext } from 'react';

import { SEO_CONTENT_PAGE_TYPE } from 'bundles/unified-seo-content-common/constants';
import type { SEOContentPageType } from 'bundles/unified-seo-content-common/types';

export type PageInfo = {
  pageType: SEOContentPageType;
};

const PageInfoContext = React.createContext<PageInfo>({ pageType: SEO_CONTENT_PAGE_TYPE.articles });

export const usePageInfo = () => {
  return useContext(PageInfoContext);
};

export default PageInfoContext;
